var exports = {
  "wrapper": "xaee3c4fa--e37014--wrapper",
  "control-wrapper": "xaee3c4fa--e37014--control-wrapper",
  "absolute": "xaee3c4fa--e37014--absolute",
  "prev": "xaee3c4fa--e37014--prev",
  "next": "xaee3c4fa--e37014--next",
  "relative": "xaee3c4fa--e37014--relative",
  "scrolling-wrapper": "xaee3c4fa--e37014--scrolling-wrapper",
};

module.exports = exports;
